/**
 * 环境检测器类
 * 支持检测Shopify网站环境、Flutter App、iOS RN App和Android RN App
 */
class EnvironmentDetector {
    /**
     * 主检测方法 - 通过多种方式检测当前环境
     * @returns {string} 检测到的环境标识
     */
    static detect() {
        // 方法1: 检查 App 注入的标识 
        if (window.shopifyAppEnv) {
            return window.shopifyAppEnv.platform;
            
        }
        
        // 方法2: 检查 URL 参数
        const urlEnv = this.detectFromURL();
        if (urlEnv) return urlEnv;
        
        // 方法3: 检查 WebView 桥接对象
        const bridgeEnv = this.detectFromBridge();
        if (bridgeEnv) return bridgeEnv;
        
        // 默认: 普通网站
        return 'shopify_website';
    }
    
    /**
     * 通过URL参数检测环境
     * @returns {string|null} 检测到的环境标识或null
     */
    static detectFromURL() {
        const params = new URLSearchParams(location.search);
        if (params.has('dreamehomeapp')) {
            return '_app';
        }
        return null;
    }
    
    /**
     * 通过WebView桥接对象检测环境
     * @returns {string|null} 检测到的环境标识或null
     */
    static detectFromBridge() {
        if (window.flutter_inappwebview) return 'flutter_app';
        if (window.webkit?.messageHandlers?.messageChannel) return 'ios_rn_app';
        if (window.jsBridge?.messageChannel) return 'android_rn_app';
        return null;
    }
}

// 初始化检测
const currentEnv = EnvironmentDetector.detect();
//console.log('环境:', currentEnv);

// 根据环境执行不同逻辑
if (currentEnv.includes('app')) {
    // App 内嵌环境的特定逻辑
    //alert('app');
    document.body.classList.add('app-embedded');
    localStorage.setItem('orderSource', currentEnv);
} else {
    // 普通网站逻辑
    document.body.classList.add('shopify-website');
}